<template>
  <div id="map" class="fill-width fill-height">
    <the-map-overlay :hovered-feature="hoveredFeature" />
    <control-buttons
      class="control-buttons"
      :class="{ 'control-buttons--position': !isSidebarVisible }"
      @zoomIn="zoomView(true)"
      @zoomOut="zoomView(false)"
      @measurementLength="addMeasurement('LineString')"
      @measurementArea="addMeasurement('Polygon')"
      @resetView="resetView"
    />
    <legend-buttons class="legend-buttons" />
    <filter-buttons
      class="filter-buttons"
      :class="{ 'filter-buttons--position': !isSidebarVisible }"
      @clearFilter="clearFilter"
    />
  </div>
</template>

<script>
import { get, sync } from 'vuex-pathify';
import Map from 'ol/Map';
import View from 'ol/View';
import { Group as LayerGroup } from 'ol/layer';

import featuresData from '@/mixins/map/featuresData';
import filters from '@/mixins/map/filters';
import identification from '@/mixins/map/identification';
import map from '@/mixins/map/map';
import measurements from '@/mixins/map/measurements';
import overlay from '@/mixins/map/overlay';
import styles from '@/mixins/map/styles';

import ControlButtons from '@/components/map/ControlButtons';
import FilterButtons from '@/components/map/FilterButtons';
import LegendButtons from '@/components/map/LegendButtons';
import TheMapOverlay from '@/components/map/TheMapOverlay';

export default {
  name: 'TheMap',
  components: { ControlButtons, FilterButtons, LegendButtons, TheMapOverlay },
  mixins: [featuresData, filters, identification, map, measurements, overlay, styles],
  data: () => ({
    map: undefined,
  }),
  computed: {
    isSidebarVisible: get('map/isSidebarVisible'),
    activeControl: sync('map/activeControl'),
  },
  mounted() {
    this.initOverlay();
    this.initMap();
  },
  methods: {
    initMap() {
      this.map = new Map({
        target: 'map',
        layers: [
          new LayerGroup({
            name: 'projectLayers',
          }),
          new LayerGroup({
            name: 'offersCartogramLayers',
          }),
        ],
        overlays: [this.overlay],
        view: new View({
          projection: this.$_config.mapDataCoordinateSystem?.epsg,
          center: this.$_config.mapDataCoordinateSystem?.center,
          constrainResolution: true,
          zoom: this.$_config.mapDefaultZoom,
          maxZoom: this.$_config.mapDefaultMaxZoom,
          minZoom: this.$_config.mapDefaultMinZoom,
        }),
        controls: [],
      });
      this.toggleProject();
      this.setTreeFilter();
      this.toggleOffersCartogram();
      this.zoomToCurrentTreeStatus();
      this.toggleIdentification(true);
      this.map.on('moveend', e => {
        const { map } = e;
        this.setZoom(map);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control-buttons {
  position: absolute;
  top: 20px;
  left: calc(50% - (467px / 2));
  z-index: 1;
  transform: translateX(-50%);
  transition: left 0.5s;
  &--position {
    left: calc(50% - (19px / 2));
  }
}
.filter-buttons {
  position: absolute;
  bottom: 20px;
  left: calc(50% - (467px / 2));
  z-index: 1;
  transform: translateX(-50%);
  transition: left 0.5s;
  &--position {
    left: calc(50% - (19px / 2));
  }
}
.legend-buttons {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 1;
}
</style>
